import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function AuthSkeleton() {
  return (
    <Box
      component="main"
      id="main"
      sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'flex-start', sm: 'center' },
        bgcolor: { xs: 'background.paper', sm: 'background.default' },
        px: { xs: 3, sm: 2 },
        py: { xs: 4, sm: 6 },
      }}
    >
      <Paper
        elevation={2}
        sx={{
          width: '100%',
          maxWidth: 420,
          bgcolor: 'background.paper',
          borderRadius: { xs: 0, sm: 2 },
          boxShadow: { xs: 'none', sm: 2 },
          p: { xs: 0, sm: 4 },
        }}
      >
        <Stack spacing={2.5}>
          <Skeleton variant="rectangular" height={32} sx={{ alignSelf: 'center', width: 160 }} />
          <Stack spacing={1}>
            <Skeleton variant="text" width="60%" sx={{ alignSelf: 'center', fontSize: '2rem' }} />
            <Skeleton variant="text" width="80%" sx={{ alignSelf: 'center' }} />
          </Stack>
          <Skeleton variant="rectangular" height={56} />
          <Skeleton variant="rectangular" height={56} />
          <Skeleton variant="rectangular" height={48} />
        </Stack>
      </Paper>
    </Box>
  );
}
